// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import EditIcon from '../assets/edit-icon.png';
import LabelIcon from '../assets/label-icon.svg';
import DatePicker from 'react-datepicker';

const S = {
  UserCardContainer: styled.div`
    width: 846px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 64px 32px 32px;
    background: #FFFFFF;
    border-radius: 4px;
  `,
  UserTitleWrapper: styled.div`
    display: flex;
    align-items: center;
    width: 468px;
  `,
  UserPictureContainer: styled.div`
    width: 120px;
    height: 120px;
    position: relative;
  `,
  UserPicture: styled.img`
    width: 120px;
    height: 120px;
    border-radius: 50%;
  `,
  UserPictureBlank: styled.div`
    width: 120px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-weight: 500;
    font-size: 36px;
    line-height: 32px;
    color: #FFFFFF;
    background: #FCA032;
  `,
  FileInput: styled.input.attrs({ type: 'file', accept: 'image/*' })`
    opacity: 0;
    display: none;
  `,
  UserPictureEditIcon: styled.img.attrs({ src: EditIcon })`
    position: absolute;
    width: 32px;
    height: 32px;
    left: 88px;
    top: 88px;
    cursor: pointer;
  `,
  UserEmailCreditWrapper: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 44px;
    overflow: hidden;
  `,
  UserEmail: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    word-wrap: break-word;
  `,
  UserCredit: styled.div`
    margin-top: 10px;
    font-size: 36px;
    line-height: 52px;
    color: #EF8200;
  `,
  UserForm: styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
  `,
  FormRow: styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
  `,
  FormRowLabel: styled.div`
    display: flex;
    align-items: center;
    margin-right: 36px;
  `,
  LabelIcon: styled.img.attrs({ src: LabelIcon })`
  `,
  LabelTitle: styled.div`
    width: 100px;
    margin-left: 12px;
    font-size: 18px;
    line-height: 26px;
    color: #434343;
  `,
  InputWrapper: styled.div<{ border?: boolean }>`
    ${({ border }) => border ? {
      border: '1px solid #C9C9C9'
    } : {
      color: '#666666'
    }}
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 24px 14px 24px;
    width: 300px;
    height: 50px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 3px;

    .react-datepicker-wrapper {
      flex-grow: 1;
    }

  `,
  Input: styled.input`
    font-size: 16px;
    line-height: 23px;
    color: #434343;

    &::placeholder {
      color: #434343;
    }
  `,
  InputCalendar: styled(DatePicker)`
    font-size: 16px;
    line-height: 23px;
    color: #434343;

    &::placeholder {
      color: #A6A6A6;
    }
    flex-grow: 1;
  `,
  IconCalendar: styled.img`
    cursor: pointer;
  `,
  ChangePassword: styled.div`
    align-self: flex-end;
    font-size: 16px;
    line-height: 23px;
    text-decoration-line: underline;
    color: #666666;
    margin: 8px 10px 0;
    cursor: pointer;
  `,
};
export { S as default };
